// Internal modules
import type {
  CountryCodes,
  LocaleTerritoryMetadata,
  Maybe,
} from '@/generated/graphql';
import { CheckoutContentLanguageCode } from '@/generated/graphql';
import { logger } from '@/lib/logger';

// All countries support en so we use that as a fallback
const FALLBACK_LANGUAGE = CheckoutContentLanguageCode.En;

type getSuggestedDefaultLanguageForCountryParams = {
  countryCode: CountryCodes;
  territories: Pick<
    LocaleTerritoryMetadata,
    'code' | 'suggestedDefaultLanguage'
  >[];
};
export const getSuggestedDefaultLanguageForCountry = ({
  countryCode,
  territories,
}: getSuggestedDefaultLanguageForCountryParams):
  | Maybe<CheckoutContentLanguageCode>
  | undefined
  | null => {
  const data = territories.find(({ code }) => code === countryCode);

  if (!data) {
    logger.info('suggested_default_langauge_not_found', {
      countryCode,
    });
    return FALLBACK_LANGUAGE;
  }

  return data.suggestedDefaultLanguage;
};
